import React from 'react';
import { FaqFormDataInterface } from '@src/apps/ContentEditor/Faq/FaqForm/types';
import DOMPurify from 'dompurify';
import { FaqDrawerConstants } from '@src/apps/constants/faq-drawer';
import { ChevronRight } from '@src/Assets/svg/ChevronRight';

interface QuestionItemProps {
  item: FaqFormDataInterface;
  isExpanded: boolean;
  onToggle: () => void;
}

export const QuestionItem: React.FC<QuestionItemProps> = ({
  item,
  isExpanded,
  onToggle
}) => {
  const sanitize = (dirty, options) => ({
    __html: DOMPurify.sanitize(dirty, { ...options }),
  });

  const handleMoreInfoClick = () => {
    if (item.MoreInfo) {
      window.open(item.MoreInfo, '_blank');
    }
  };

  return (
    <div className={`question-item ${isExpanded ? 'expanded' : ''}`}>
      <div className="question-state" onClick={onToggle}>
        <span className="question-text">
          {item.Question} [{isExpanded ? '–' : '+'}]
        </span>
      </div>
      {isExpanded && (
        <>
          <div className="answer-text" dangerouslySetInnerHTML={sanitize(item.Answer, { FORBID_ATTR: ["style"] })} />
          {item.MoreInfo && item.MoreInfo !== "" && <button className="more-info-button" onClick={handleMoreInfoClick}>{FaqDrawerConstants.moreInfo} <ChevronRight width={10} height={10}/> </button>}
        </>
      )}
    </div>
  );
};
